// import pacchetti
import React from "react";
import { useState, useEffect, useMemo } from "react";
import { filesCloud } from "../../firebase/config";
import Select from "react-select";
import format from "date-fns/format";
import { it } from "date-fns/locale";

// import hooks
import { useFirestore } from "../../hooks/useFirestore";
import { useCollection } from "../../hooks/useCollection";
import { useEmailNotifications } from "../../hooks/useEmailNotifications";

const competenze = [
  { value: format(new Date(), "d MMM y", { locale: it }), label: "Oggi" },
  { value: "Gennaio", label: "Gennaio" },
  { value: "Febbraio", label: "Febbraio" },
  { value: "Marzo", label: "Marzo" },
  { value: "Aprile", label: "Aprile" },
  { value: "Maggio", label: "Maggio" },
  { value: "Giugno", label: "Giugno" },
  { value: "Luglio", label: "Luglio" },
  { value: "Agosto", label: "Agosto" },
  { value: "Settembre", label: "Settembre" },
  { value: "Ottobre", label: "Ottobre" },
  { value: "Novembre", label: "Novembre" },
  { value: "Dicembre", label: "Dicembre" },
  { value: "13ma", label: "13ma" },
];

// Genera automaticamente gli anni da 2022 all'anno corrente + 2
const anni = (() => {
  const annoIniziale = 2022;
  const annoCorrente = new Date().getFullYear();
  const anniTotali = [{ value: "tutti", label: "Tutti gli anni" }];

  for (let anno = annoIniziale; anno <= annoCorrente + 2; anno++) {
    anniTotali.push({
      value: anno.toString(),
      label: anno.toString(),
    });
  }

  return anniTotali;
})();

// Opzioni per il tipo di documento
const tipiDocumento = [
  { value: "bustaPaga", label: "Busta Paga" },
  { value: "cud", label: "CUD" },
  { value: "addebitoPersonale", label: "Addebito Personale" },
  { value: "altro", label: "Altro" },
];

export default function AggiungiDoc() {
  const { addDocument, response } = useFirestore("documenti");
  const { documents } = useCollection("users");
  const { sendEmail } = useEmailNotifications();

  // state per controllare gli input
  const [identificativo, setIdentificativo] = useState("");
  const [importo, setImporto] = useState("");
  const [tipoDocumento, setTipoDocumento] = useState(null);
  const [competenza, setCompetenza] = useState("");
  const [annoCompetenza, setAnnoCompetenza] = useState("");
  const [owner, setOwner] = useState("");
  const [dipendenti, setDipendenti] = useState(null);
  const [documento, setDocumento] = useState(null);
  const [fileError, setFileError] = useState(null);
  const [formError, setFormError] = useState(null);
  const [uploadCompletato, setUploadCompletato] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const usersById = useMemo(() => {
    const map = new Map();
    if (documents) {
      documents.forEach((u) => {
        map.set(u.id, u);
      });
    }
    return map;
  }, [documents]);

  useEffect(() => {
    if (documents) {
      const options = documents.map((user) => {
        let label = user.displayName;
        if (user.anagrafica) {
          label = `${user.anagrafica.nome} ${user.anagrafica.cognome}`;
        }
        return {
          value: user.id,
          label: label,
        };
      });
      setDipendenti(options);
    }
  }, [documents]);

  const handleFileChange = (e) => {
    setDocumento(null);
    setFileError(null);
    let selected = e.target.files[0];
    console.log(selected);
    if (!selected) {
      setFileError("Inserisci un file");
      return;
    }
    setDocumento(selected);
    console.log("File Presente");
    console.log(owner);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormError(null);

    if (!tipoDocumento) {
      setFormError("Seleziona un tipo di documento");
      return;
    }

    if (
      (tipoDocumento.value === "altro" ||
        tipoDocumento.value === "addebitoPersonale") &&
      !identificativo
    ) {
      setFormError("Inserisci una descrizione per il documento");
      return;
    }

    if (tipoDocumento.value === "addebitoPersonale" && !importo) {
      setFormError("Inserisci un importo");
      return;
    }

    if (!competenza) {
      // setFormError("Seleziona un periodo di competenza");
      setCompetenza("");
    }

    if (!owner) {
      setFormError("Seleziona un dipendente");
      return;
    }

    if (!documento) {
      setFormError("Inserisci un file");
      return;
    }

    const ownerUser = usersById.get(owner.value) || null;
    const ownerEmail =
      String(
        ownerUser?.email || ownerUser?.anagrafica?.emailGoogle || "",
      ).trim() || "";

    if (!ownerEmail) {
      setFormError("Email del dipendente non presente");
      return;
    }

    try {
      setIsSubmitting(true);

      const competenzaValue = competenza?.value || "";
      const annoCompetenzaValue = annoCompetenza?.value || "";

      // upload foto spesa. creiamo il percorso in cui salvare il file
      const uploadPath = `documenti/${owner.label}/${documento.name}`;
      // funzione asincrona, utilizziamo ref passando come argomento il percorso e utilizziamo il metodo put per caricare
      const doc = await filesCloud.ref(uploadPath).put(documento);
      // recuperiamo l'URL dell'immagine appena caricata NON FUNZIONA!!!!
      const downloadUrl = await doc.ref.getDownloadURL();
      //console.log(imageUrl);

      const docObj = {
        identificativo:
          tipoDocumento.value === "altro" ||
          tipoDocumento.value === "addebitoPersonale"
            ? identificativo
            : tipoDocumento.label,
        competenza: competenzaValue,
        anno: annoCompetenzaValue,
        owner: owner.value,
        downloadUrl,
        tipoDocumento: tipoDocumento.value,
        importo: tipoDocumento.value === "addebitoPersonale" ? importo : null,
      };
      console.log(docObj);
      await addDocument(docObj);

      const documentsUrl =
        typeof window !== "undefined"
          ? `${window.location.origin}/documenti`
          : "/documenti";

      const mailRef = await sendEmail({
        to: ownerEmail,
        subject: "Nuovo documento disponibile",
        text: `È stato inserito un nuovo documento a te assegnato.\nTipo: ${tipoDocumento.label}\nCompetenza: ${competenzaValue || "-"} ${annoCompetenzaValue || ""}\n\nPuoi accedere alla pagina documenti e scaricarlo da qui:\n${documentsUrl}\n`,
        data: {
          type: "documento_inserito",
          dipendente: ownerUser,
          documento: docObj,
          links: { documenti: documentsUrl },
        },
      });

      if (!mailRef) {
        throw new Error("EMAIL_DOC_NOT_CREATED");
      }
    } catch (err) {
      setFormError(
        "Documento caricato, ma notifica email non inviata correttamente.",
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    if (response.success) {
      setUploadCompletato("Documento caricato con successo");
      setTimeout(() => {
        setUploadCompletato(null);
      }, 5000);
    }
  }, [response.success]);

  return (
    <div className="create-form">
      <h2 className="page-title">Aggiungi Documento</h2>
      <form onSubmit={handleSubmit}>
        <label>
          <span>Tipo di documento:</span>
          <Select
            onChange={(option) => setTipoDocumento(option)}
            options={tipiDocumento}
            isSearchable={false}
          />
        </label>

        {tipoDocumento &&
          (tipoDocumento.value === "altro" ||
            tipoDocumento.value === "addebitoPersonale") && (
            <label>
              <span>Descrizione:</span>
              <input
                required
                type="text"
                onChange={(e) => setIdentificativo(e.target.value)}
                value={identificativo}
              />
            </label>
          )}

        {tipoDocumento && tipoDocumento.value === "addebitoPersonale" && (
          <label>
            <span>Importo (€):</span>
            <input
              required
              type="number"
              step="0.01"
              onChange={(e) => setImporto(e.target.value)}
              value={importo}
            />
          </label>
        )}

        <label>
          <span>Periodo di competenza:</span>
          <Select
            onChange={(option) => setCompetenza(option)}
            options={competenze}
            isSearchable={false}
          />
        </label>
        <label>
          <span>Anno di competenza:</span>
          <Select
            onChange={(option) => setAnnoCompetenza(option)}
            options={anni}
            isSearchable={false}
          />
        </label>
        <label>
          <span>Dipendente:</span>
          <Select
            onChange={(option) => setOwner(option)}
            options={dipendenti}
            isSearchable={true}
          />
        </label>
        <label>
          <span>Documento:</span>
          <input
            type="file"
            id="docFile"
            accept="image/*, .pdf"
            onChange={handleFileChange}
          />
          {fileError && <div className="error">{fileError}</div>}
        </label>
        <button className="btn" disabled={isSubmitting}>
          {isSubmitting ? "Invio in corso..." : "Inserisci Documento"}
        </button>
        {formError && <p className="error">{formError}</p>}
        {uploadCompletato && <p className="success">{uploadCompletato}</p>}
      </form>
      <br />
    </div>
  );
}
